import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

// Delad header som används på alla SEO-sidor — säkerställer konsekvent navigation + interna länkar.
export const SEONavbar = ({ activePage = '' }) => (
  <header className="fixed top-0 left-0 right-0 z-40 bg-[#F7F4EF]/90 backdrop-blur-md border-b border-[#E8E2D9]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between gap-2">
      <Link to="/" className="flex items-center gap-2 flex-shrink-0" aria-label="Operio – startsida">
        <img src="/operio-logo-2.png" alt="Operio logotyp" className="h-7 sm:h-8 w-auto" />
      </Link>
      <nav className="hidden md:flex items-center gap-7 text-sm text-[#6B6560]" aria-label="Huvudnavigation">
        <Link to="/bygg-kalkyl-program" className={activePage === 'kalkyl' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Kalkyl</Link>
        <Link to="/tidrapportering-bygg" className={activePage === 'tid' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Tidrapportering</Link>
        <Link to="/priser" className={activePage === 'priser' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Priser</Link>
        <Link to="/blogg" className={activePage === 'blogg' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Blogg</Link>
        <Link to="/about" className={activePage === 'om' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Om oss</Link>
        <Link to="/kontakt" className={activePage === 'kontakt' ? 'text-[#1A1A1A] font-medium' : 'hover:text-[#1A1A1A]'}>Kontakt</Link>
      </nav>
      <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        <Link to="/login" className="text-xs sm:text-sm font-medium text-[#6B6560] hover:text-[#1A1A1A] transition-colors px-2">
          Logga in
        </Link>
        <Link to="/register">
          <Button className="bg-[#E8613A] hover:bg-[#D4532F] text-white text-xs sm:text-sm h-8 sm:h-9 px-3 sm:px-5 rounded-full whitespace-nowrap">
            Kom igång<span className="hidden sm:inline"> gratis</span>
          </Button>
        </Link>
      </div>
    </div>
  </header>
);

// Delad footer med rik internlänkning (viktigt för SEO-juice).
export const SEOFooter = () => (
  <footer className="py-12 px-5 sm:px-6 border-t border-[#E8E2D9] bg-[#F2EEE7]">
    <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-8">
      <div className="col-span-2">
        <Link to="/" className="flex items-center gap-2">
          <img src="/operio-logo-2.png" alt="Operio" className="h-7 w-auto" />
        </Link>
        <p className="text-sm text-[#6B6560] mt-3 max-w-xs">
          AI-plattformen som digitaliserar bygg-, mark- och entreprenadföretag i Sverige.
        </p>
        <p className="text-xs text-[#7A7570] mt-4">&copy; 2026 Operio AB · Skövde, Sverige</p>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-[#1A1A1A] mb-3">Produkt</h4>
        <ul className="space-y-2 text-sm text-[#6B6560]">
          <li><Link to="/bygg-kalkyl-program" className="hover:text-[#1A1A1A]">Bygg kalkyl­program</Link></li>
          <li><Link to="/tidrapportering-bygg" className="hover:text-[#1A1A1A]">Tidrapportering</Link></li>
          <li><Link to="/priser" className="hover:text-[#1A1A1A]">Priser</Link></li>
          <li><Link to="/register" className="hover:text-[#1A1A1A]">Starta gratis</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-[#1A1A1A] mb-3">Företag</h4>
        <ul className="space-y-2 text-sm text-[#6B6560]">
          <li><Link to="/about" className="hover:text-[#1A1A1A]">Om oss</Link></li>
          <li><Link to="/blogg" className="hover:text-[#1A1A1A]">Blogg</Link></li>
          <li><Link to="/kontakt" className="hover:text-[#1A1A1A]">Kontakt</Link></li>
          <li><a href="mailto:kontakt@operio.nu" className="hover:text-[#1A1A1A]">kontakt@operio.nu</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-wider text-[#1A1A1A] mb-3">Logga in</h4>
        <ul className="space-y-2 text-sm text-[#6B6560]">
          <li><Link to="/login" className="hover:text-[#1A1A1A]">Admin</Link></li>
          <li><Link to="/worker/login" className="hover:text-[#1A1A1A]">Anställda</Link></li>
          <li><Link to="/customer/login" className="hover:text-[#1A1A1A]">Kundportal</Link></li>
        </ul>
      </div>
    </div>
  </footer>
);
